import { render, staticRenderFns } from "./CompleteSubStatusComponent.vue?vue&type=template&id=3a42d921&"
import script from "./CompleteSubStatusComponent.vue?vue&type=script&lang=ts&"
export * from "./CompleteSubStatusComponent.vue?vue&type=script&lang=ts&"
import style0 from "./CompleteSubStatusComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VList,VListItem,VMenu})
